class SectionHeader {
  constructor() {
    this.isOpen = false;

    this.bindUI();
    this.bindEvents();
    this.init();
  }

  bindUI() {
    this.panel = document.querySelector('.js-mobile-menu-panel');
    this.toggleBtn = document.querySelector('.js-mobile-menu-toggle');
    this.burgerIcon = document.querySelector('.js-burger-icon');
    this.closeIcon = document.querySelector('.js-close-icon');
  }

  bindEvents() {
    this.toggleBtn.addEventListener('click', () => this.toggle());
    this.bindKeyboardEvents();
    this.bindClickOutside();
  }

  init() {
    this.timeline = gsap.timeline({
      paused: true,
      onStart: () => {
        document.body.style.overflow = 'hidden';
        document.dispatchEvent(new CustomEvent('header:open'));
      },
      onReverseComplete: () => {
        document.body.style.overflow = '';
      }
    });
    this.timeline.from(this.panel, {
      x: '-100%',
      duration: 0.5,
      ease: 'power2.inOut'
    });
  }

  bindKeyboardEvents() {
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.close();
      }
    });
  }

  bindClickOutside() {
    document.addEventListener('click', (e) => {
      if (this.isOpen && !this.panel.contains(e.target) && !this.toggleBtn.contains(e.target)) {
        this.close();
      }
    });
  }

  toggle() {
    this.isOpen ? this.close() : this.open();
  }

  open() {
    this.isOpen = true;
    this.updateIcons();
    this.timeline.play();
  }

  close() {
    this.isOpen = false;
    this.updateIcons();
    this.timeline.reverse();
  }

  updateIcons() {
    this.burgerIcon?.classList.toggle('opacity-0', this.isOpen);
    this.closeIcon?.classList.toggle('opacity-0', !this.isOpen);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new SectionHeader();
});
